const IMAGE_REF_TYPES = new Set(["images", "cadviews"]);

function imageUrl(base, userId, refId, refType) {
  return `${base}/api/original-image?reference_id=${refId}&reference_type=${refType}&user_id=${userId}`;
}

/**
 * Build the Views gallery list from step_images, injecting an orphaned
 * reference_* image as "Original" when it is not already listed.
 */
export function buildStepViews(stepData, { base, userId } = {}) {
  const fromGallery = (stepData?.step_images || []).map((img, i) => {
    const rawName = img.file_name ?? "";
    const label = rawName
      ? rawName.replace(/\.[^.]+$/, "")
      : `Image ${i + 1}`;
    return {
      id: `img-${img.reference_id ?? i}`,
      src: imageUrl(base, userId, img.reference_id, img.reference_type),
      label,
      reference_id: img.reference_id ?? null,
      reference_type: img.reference_type ?? "images",
      file_id: img.file_id ?? null,
      file_name: img.file_name ?? null,
    };
  });

  const refType = stepData?.reference_type;
  const refId = stepData?.reference_id;
  const isImageRef =
    refId != null &&
    refId !== "" &&
    IMAGE_REF_TYPES.has(refType);
  const alreadyListed =
    isImageRef &&
    fromGallery.some(img => String(img.reference_id) === String(refId));

  if (isImageRef && !alreadyListed) {
    fromGallery.unshift({
      id: `img-${refId}`,
      src: imageUrl(base, userId, refId, refType),
      label: "Original",
      reference_id: refId,
      reference_type: refType,
      file_id: null,
      file_name: "Original",
    });
  }

  return fromGallery;
}

/**
 * Resolve the persisted primary / default view from step reference_*.
 * @returns {{ kind: "gltf" } | { kind: "image", reference_id: any, reference_type?: string } | null}
 */
export function resolveActiveView(stepData, is3D = false) {
  const refType = stepData?.reference_type;
  const refId = stepData?.reference_id;

  if (refType === "gltf") {
    return { kind: "gltf" };
  }

  if (refId != null && refId !== "" && IMAGE_REF_TYPES.has(refType)) {
    return {
      kind: "image",
      reference_id: refId,
      reference_type: refType,
    };
  }

  // 3D DPM with unset/empty primary → treat as gltf.
  if (is3D && (refId == null || refId === "" || !refType)) {
    return { kind: "gltf" };
  }

  return null;
}
